<template>
    <div class="publication__edit content-width">

        <div class="publication__edit-wrapper" v-for="c in initial">
            <component :is="c.component.name" :server="server" :key="c.component.name"></component>
        </div>

    </div>
</template>

<script>


const components = [
    { component: PublicationCreateProject },
    { component: SelectLocation },
    { component: PublicationEditPreview },
    { component: PublicationSliderGallery },
    { component: PublicationDonations },
]

import StateMixin from "../mixins/StateMixin";

import PublicationCreateProject from "./PublicationCreateProject";
import SelectLocation from "./SelectLocation";
import PublicationEditPreview from "./PublicationEditPreview";
import PublicationSliderGallery from "./PublicationSliderGallery";
import PublicationDonations from "./PublicationDonations";


export default {
    name: "PublicationEdit",
    props: ['server'],
    mixins: [StateMixin],
    components: {
        PublicationCreateProject, SelectLocation, PublicationEditPreview, PublicationSliderGallery, PublicationDonations,
    },

    computed: {
        initial() {
            return components
        },
    },

    methods: {
        handleSliderHeight(){
            this.$parent.handleSliderHeight()
        },

        isValid(){
           const v = this.$children.map( e => {
               return e.isValid();
           } );

           if( v.includes(false) ){
               this.$emit('parent-update', false );
               return false
           }

           this.$emit('parent-update', true );
           return true

        }

    },

}
</script>

<style scoped>

</style>
